import { useSyncExternalStore } from "react";

const KEY = "calendarHideCancelledSlots";

const subscribe = (callback: () => void) => {
  window.addEventListener("storage", callback);
  return () => window.removeEventListener("storage", callback);
};

const getSnapshot = () => {
  const item = localStorage.getItem(KEY);
  if (!item) return "false";
  return item;
};

const setValue = (value: boolean) => {
  localStorage.setItem(KEY, JSON.stringify(value));
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: KEY,
      newValue: JSON.stringify(value),
    }),
  );
};

export const useCalendarHideCancelledSlots = () => {
  const booleanValue = useSyncExternalStore(subscribe, getSnapshot);

  const parseBoolean = (value: string) => {
    return value === "true";
  };

  const value = parseBoolean(booleanValue);

  return [value, setValue] as const;
};
